export default __webpack_public_path__ + "static/media/logo-filial.f342b38c.jpg";